import {IMAGE_URL} from "../../../URL";
import {useSelector} from "react-redux";

export const BoardPhotos = ({setShowBackgroundPicker, moreStyles, handleSelectImage}) => {
    const selectedImage = useSelector(state => state.boardCreate.selectedImage);
    return (
        <div className="backgroundPicker">
            <div className="backgroundPicker__header">
                <h3>Board background</h3>
                <button
                    type="button"
                    className="backgroundPicker__close"
                    onClick={() => setShowBackgroundPicker(false)}
                >
                    ×
                </button>
            </div>

            <div className="backgroundPicker__section">
                <div className="backgroundPicker__sectionTop">
                    <h4>Photos</h4>
                    <button type="button" className="backgroundPicker__viewMore">
                        View more
                    </button>
                </div>

                <div className="backgroundPicker__grid">
                    {moreStyles.map((el) => {
                        const imageURL = IMAGE_URL + "/media/" + el.path;

                        return (
                            <button
                                type="button"
                                key={el.id}
                                className={`backgroundPicker__photo ${
                                    selectedImage?.id === el.id ? "active" : ""
                                }`}
                                onClick={() => handleSelectImage(el)}
                            >
                                <img src={imageURL} alt="style"/>
                                {selectedImage?.id === el.id && (
                                    <span className="backgroundPicker__check">
                                                        ✓
                                                    </span>
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}